import React from 'react'
import { useResendCode } from './useResendCode'
import { BusyButton } from '@ztechapps/webui.button'

export const ResendCode = () => {
  const [onResendCode, { loading }] = useResendCode()

  return (
    <div className="fw-bold">
      <BusyButton bsStyle="link" isBusy={loading} busyText="Resending...." onClick={onResendCode} icon="key">
        <span className="fw-bold">Resend if you did not receive the code</span>
      </BusyButton>
    </div>
  )
}
